"use client";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "next/image";
function slider({ Mydata }) {
  const data = Mydata[2];
  // console.log(data, "wasa");
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="mb-10">
      <div className="mx-auto max-w-7xl  ">
        <div className="text-center px-6">
          <h2 className="text-3xl secondary font-bold">
            <span className="text-[#D5AF34]">{data.subtitle}</span> {data.title}
          </h2>
          <p
            className="updatedparapremu pt-4 mb-6"
            dangerouslySetInnerHTML={{ __html: data.des }}
          ></p>
        </div>
      </div>

      {/*=========================================  */}

      <div className="mx-auto max-w-7xl px-3 ">
        <Slider {...sliderSettings} className="custom-slider-width">
          {data.slider.map((item, index) => (
            <div className="text-center   gap-12 px-2 ">
              <div className="gap-2 slie airportslider  rounded-2xl px-3">
                <div className="flex justify-center pt-4 mb-4">
                  <Image
                    src={item.image}
                    height={90}
                    width={90}
                    alt={item.alt}
                    title={item.alt}
                    loading="lazy"
                  />
                </div>
                <h2 className="updatedheading">{item.title}</h2>
                <p
                  className="updatedparapremu  pt-4 pb-3 "
                  dangerouslySetInnerHTML={{ __html: item.des }}
                ></p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default slider;
